// import React, {Fragment, useState} from 'react';
const MessageContentReader = ({message}) =>{
    return message.text;
}

export default MessageContentReader;